<template>
    <div v-if="hasAuth('Admin')">
        <list-container :header="translate('ozneList.eypDefinitions')" v-show="!$route.params.id">
            <div v-if="!hasModule('EYP')">
                <div class="alert alert-warning" style="border-radius:0; border-left:0; border-right:0">
                    {{translate('warnings.eypModuleNotActive2')}}
                </div>
            </div>
            <template v-slot:commands>
                <excel-exporter table-id="ozneExport" :columns="columns" url="/ozne/get" modelName="Ozne"  orderBy="DisplayName"></excel-exporter>
                <button v-if="hasModule('EYP')" class="btn btn-primary" @click="$router.push({ name:'OzneDetail', params: { id: '000000000000000000000000' }, query: { kind: 'TuzelSahis' } })">
                    {{translate('ozneList.addNewEyp')}}
                </button>
            </template>
            <list :columns="columns" url="/ozne/get" modelName="Ozne"  orderBy="IsActive desc,DisplayName">

            </list>
        </list-container>
        <router-view v-if="$route.params.id"/>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import Vue from 'vue'
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'
import ExcelExporter from '../components/ExcelExporter.vue';

export default {
    data(){
        return {
            columns : [
                {
                    Key: "DisplayName",
                    Title: this.translate('categoryList.columns.name'),
                    SortField: "DisplayName"
                },
                {
                    Key: "Kind",
                    Title: this.translate('categoryList.columns.type'),
                    SortField: "Kind",
                    Content(i) {
                        return Vue.filter('ozneKind')(i.Kind);
                    }
                },
                 {
                    Key: "DisplayName",
                    Title: this.translate('ozne.ozneType'),
                    SortField: "DisplayName",
                    Content(i) {
                        return Vue.filter('ozneTipi')(i.OzneTipi);
                    }
                },
                {
                    Key: "IsActive",
                    Title: this.translate('targetSystemImport.active'),
                    SortField: "IsActive",
                    Class: "text-center",
                    Content(i) {
                        return Vue.filter('checkicon')(i.IsActive);
                    }
                }
            ]
        }
    },
    components: {
        list,ExcelExporter,
        listContainer
    },
    methods: { 
    }
}
</script>